import { useState } from "react";

export const useBool = (initialState: boolean) => {
  const [bool, setBool] = useState<boolean>(initialState);

  const flipBool = (): void => {
    setBool(prevVal => !prevVal);
  };

  return { bool, setBool, flipBool };
};